const topics = [
  { label: '流浪地球3', heat: '98万讨论', hot: true },
  { label: '庆余年3', heat: '86万讨论', hot: true },
  { label: '哪吒2', heat: '210万讨论', hot: true },
  { label: '鬼灭之刃', heat: '65万讨论', hot: true },
  { label: '奥本海默', heat: '43万讨论', hot: false },
  { label: '乘风破浪', heat: '120万讨论', hot: true },
  { label: '沙丘2', heat: '38万讨论', hot: false },
  { label: '奔跑吧', heat: '95万讨论', hot: true },
  { label: '想见你', heat: '52万讨论', hot: false },
  { label: '繁花', heat: '78万讨论', hot: true },
  { label: '三体', heat: '105万讨论', hot: true },
];

export default function Topics() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            全网影视热议焦点，8090观众都在讨论的精彩内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((item, idx) => (
            <div
              key={idx}
              className={`relative group cursor-pointer px-5 py-3 rounded-xl border transition-all duration-300 ${
                item.hot
                  ? 'bg-accent-500/8 border-accent-500/20 hover:bg-accent-500/15 hover:border-accent-500/30'
                  : 'bg-background-100 border-background-200/60 hover:bg-background-200/50 hover:border-background-300/60'
              }`}
            >
              <div className="flex items-center gap-2">
                {item.hot && (
                  <span className="flex-shrink-0 w-5 h-5 rounded-full bg-accent-500/20 flex items-center justify-center">
                    <i className="ri-fire-line text-[10px] text-accent-400"></i>
                  </span>
                )}
                <span className="font-heading text-sm md:text-base font-bold text-foreground-800 whitespace-nowrap">
                  {item.label}
                </span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}